// bb8-api rejects a startDate/endDate span over 366 days for availability/bulk and prices/bulk
// (InvalidDateException::fromRangeTooWide, AS-2587); bookings_quantity/bulk doesn't enforce this
// server-side at all. Shared here so the UI can reject the same range before ever dispatching a
// fetch, not just bulkApi.ts as a last-resort safety net.
export const MAX_BULK_DATE_RANGE_DAYS = 366;

export function daysBetween(startDate: string, endDate: string): number {
  return Math.round(
    (new Date(`${endDate}T00:00:00Z`).getTime() - new Date(`${startDate}T00:00:00Z`).getTime()) / 86400000,
  );
}

export function isDateRangeTooWide(startDate: string, endDate: string): boolean {
  return daysBetween(startDate, endDate) > MAX_BULK_DATE_RANGE_DAYS;
}
